<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post19-vessels-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post19-vessels-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.3914590747331;"
    data-aspect-ratio="0.391"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post19-vessels-xs-img"
      class="g-post19-vessels-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-vessels-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.5109%;margin-top:-7.5px;left:30.5263%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle1">Iraq</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.3511%;margin-top:-7.5px;left:73.3222%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle2">Iran</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:11.2048%;margin-top:-7.5px;left:63.4271%;width:81px;"
    >
      <p class="g-pstyle3">Oil terminals</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.289%;margin-top:-7.5px;left:73.6889%;width:98px;"
    >
      <p class="g-pstyle4">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai0-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:85.063%;margin-top:-8.1px;right:51.6264%;width:64px;"
    >
      <p class="g-pstyle12">Muajjiz</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:15.1984%;margin-top:-8.1px;left:7.4611%;width:142px;"
    >
      <p class="g-pstyle6">East-West pipeline</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.7801%;margin-top:-7.5px;right:45.8814%;width:63px;"
    >
      <p class="g-pstyle7">Juaymah</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.2712%;margin-top:-7.5px;right:30.3985%;width:55px;"
    >
      <p class="g-pstyle8">Qatar</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.7457%;margin-top:-7.5px;left:10.6416%;width:51px;"
    >
      <p class="g-pstyle3">Yanbu</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:22.3555%;margin-top:-7.5px;right:38.4061%;width:73px;"
    >
      <p class="g-pstyle7">Ras Tanura</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:22.5927%;margin-top:-7.5px;left:71.7513%;margin-left:-21px;width:42px;"
    >
      <p class="g-pstyle1">UAE</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.3045%;margin-top:-7.5px;left:17.963%;width:55px;"
    >
      <p class="g-pstyle3">Muajjiz</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.0015%;margin-top:-15.6px;left:52.3094%;width:138px;"
    >
      <p class="g-pstyle6">Habshan-Fujairah</p>
      <p class="g-pstyle6">pipeline</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.1004%;margin-top:-14.5px;left:35.9165%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle1">Saudi</p>
      <p class="g-pstyle1">Arabia</p>
    </div>
    <div
      id="g-ai0-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.7415%;margin-top:-8.1px;right:1.5516%;width:84px;"
    >
      <p class="g-pstyle12">MARCH 15</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.9474%;margin-top:-7.5px;left:73.4774%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle1">Oman</p>
    </div>
    <div
      id="g-ai0-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.8912%;margin-top:-32.6px;left:0.6861%;width:328px;"
    >
      <p class="g-pstyle15">Tanker traffic in Saudi Red Sea ports increased</p>
      <p class="g-pstyle15">
        significantly between March 2 (<span class="g-cstyle0">97 vessels</span
        >)
      </p>
      <p class="g-pstyle15">
        and March 15 (<span class="g-cstyle0">134 vessels</span>), suggesting a
        buildup
      </p>
      <p class="g-pstyle15">in oil export activity.</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.862%;margin-top:-7.5px;left:46.9934%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle1">Yemen</p>
    </div>
    <div
      id="g-ai0-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.8608%;margin-top:-7.5px;left:88.1314%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle9">500km</p>
    </div>
    <div
      id="g-ai0-21"
      class="g-text g-aiAbs"
      style="top:45.6702%;left:0.4954%;width:75.7576%;"
    >
      <p class="g-pstyle10">
        Tanker queue builds at Yanbu as Saudi Arabia reroutes exports from the
        Gulf
      </p>
      <p class="g-pstyle11">(March 17)</p>
    </div>
    <div
      id="g-ai0-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.3904%;margin-top:-8.1px;right:0.5467%;width:79px;"
    >
      <p class="g-pstyle12">MARCH 2</p>
    </div>
    <div
      id="g-ai0-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.7119%;margin-top:-8.1px;right:49.5833%;width:64px;"
    >
      <p class="g-pstyle12">Muajjiz</p>
    </div>
    <div
      id="g-ai0-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.3416%;margin-top:-15.5px;left:79.7369%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle13">Saudi</p>
      <p class="g-pstyle13">Arabia</p>
    </div>
    <div
      id="g-ai0-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:90.6927%;margin-top:-15.5px;left:77.1643%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle13">Saudi</p>
      <p class="g-pstyle13">Arabia</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:1.1415%;margin-top:-7.6px;left:0.1884%;width:286px;"
    >
      <p class="g-pstyle0">Pipelines bypassing the Strait of Hormuz</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:33.6247%;margin-top:-7.5px;left:89.5693%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle5">Arabia Sea</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:29.2357%;margin-top:-7.5px;left:17.8237%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle5">Red Sea</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:14.6449%;margin-top:-7.5px;left:57.504%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle5">The Gulf</p>
    </div>
    <div
      id="g-ai0-30"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:95.8578%;margin-top:-8.1px;left:8.0389%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle14">Red Sea</p>
    </div>
    <div
      id="g-ai0-25"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:67.5066%;margin-top:-8.1px;left:10.6114%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle14">Red Sea</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post19-vessels-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.56167400881057;"
    data-aspect-ratio="0.562"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post19-vessels-sm-img"
      class="g-post19-vessels-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-vessels-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.3461%;margin-top:-8.6px;left:70.4033%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle1">Iran</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.4383%;margin-top:-8.5px;left:36.9954%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle2">Iraq</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:11.8527%;margin-top:-8.6px;left:62.6834%;width:103px;"
    >
      <p class="g-pstyle3">Oil terminals</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:15.2668%;margin-top:-8.6px;left:70.7391%;width:125px;"
    >
      <p class="g-pstyle4">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai1-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.1323%;margin-top:-8.1px;right:54.5818%;width:64px;"
    >
      <p class="g-pstyle12">Muajjiz</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.3727%;margin-top:-8.7px;left:18.748%;width:150px;"
    >
      <p class="g-pstyle6">East-West pipeline</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.0201%;margin-top:-8.6px;right:44.6063%;width:78px;"
    >
      <p class="g-pstyle7">Juaymah</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:20.9845%;margin-top:-8.5px;right:32.4709%;width:61px;"
    >
      <p class="g-pstyle8">Qatar</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:21.3241%;margin-top:-8.6px;left:21.2447%;width:61px;"
    >
      <p class="g-pstyle3">Yanbu</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:24.2976%;margin-top:-8.6px;right:38.6755%;width:92px;"
    >
      <p class="g-pstyle7">Ras Tanura</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:24.729%;margin-top:-8.5px;left:69.2547%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle2">UAE</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.399%;margin-top:-8.6px;left:26.9926%;width:67px;"
    >
      <p class="g-pstyle3">Muajjiz</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.5885%;margin-top:-16.7px;left:53.9557%;width:146px;"
    >
      <p class="g-pstyle6">Habshan-Fujairah</p>
      <p class="g-pstyle6">pipeline</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.685%;margin-top:-16.5px;left:41.114%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle2">Saudi</p>
      <p class="g-pstyle2">Arabia</p>
    </div>
    <div
      id="g-ai1-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.0486%;margin-top:-8.1px;right:22.1804%;width:84px;"
    >
      <p class="g-pstyle12">MARCH 15</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.9889%;margin-top:-8.5px;left:70.6087%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai1-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.2712%;margin-top:-34.6px;left:16.4771%;width:328px;"
    >
      <p class="g-pstyle15">Tanker traffic in Saudi Red Sea ports increased</p>
      <p class="g-pstyle15">
        significantly between March 2 (<span class="g-cstyle0">97 vessels</span
        >)
      </p>
      <p class="g-pstyle15">
        and March 15 (<span class="g-cstyle0">134 vessels</span>), suggesting a
        buildup
      </p>
      <p class="g-pstyle15">in oil export activity.</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.3942%;margin-top:-8.5px;left:49.7457%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle2">Yemen</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.6541%;margin-top:-8.5px;left:81.0813%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle9">500km</p>
    </div>
    <div
      id="g-ai1-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.7294%;margin-top:-16.6px;left:1.1228%;width:517px;"
    >
      <p class="g-pstyle10">
        Tanker queue builds at Yanbu as Saudi Arabia reroutes exports from the
        Gulf
      </p>
      <p class="g-pstyle11">(March 17)</p>
    </div>
    <div
      id="g-ai1-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:54.5243%;margin-top:-8.1px;right:21.5303%;width:79px;"
    >
      <p class="g-pstyle12">MARCH 2</p>
    </div>
    <div
      id="g-ai1-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.608%;margin-top:-8.1px;right:53.2598%;width:64px;"
    >
      <p class="g-pstyle12">Muajjiz</p>
    </div>
    <div
      id="g-ai1-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.8348%;margin-top:-15.5px;left:65.7121%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle13">Saudi</p>
      <p class="g-pstyle13">Arabia</p>
    </div>
    <div
      id="g-ai1-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:91.359%;margin-top:-15.5px;left:64.0476%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle13">Saudi</p>
      <p class="g-pstyle13">Arabia</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:1.0598%;margin-top:-7.6px;left:0.318%;width:286px;"
    >
      <p class="g-pstyle0">Pipelines bypassing the Strait of Hormuz</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:37.073%;margin-top:-8.6px;left:83.2186%;margin-left:-44.5px;width:89px;"
    >
      <p class="g-pstyle5">Arabia Sea</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:32.0069%;margin-top:-8.6px;left:26.9673%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle5">Red Sea</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:15.7073%;margin-top:-8.6px;left:58.0637%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle5">The Gulf</p>
    </div>
    <div
      id="g-ai1-30"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:96.1543%;margin-top:-8.1px;left:19.3193%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle14">Red Sea</p>
    </div>
    <div
      id="g-ai1-25"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:67.6301%;margin-top:-8.1px;left:20.9838%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle14">Red Sea</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post19-vessels-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.87186261558785;"
    data-aspect-ratio="0.872"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post19-vessels-md-img"
      class="g-post19-vessels-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-vessels-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.2855%;margin-top:-8.6px;left:9.7354%;width:73px;"
    >
      <p class="g-pstyle1">Jordan</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.4231%;margin-top:-8.6px;left:63.857%;width:103px;"
    >
      <p class="g-pstyle2">Oil terminals</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.0815%;margin-top:-8.7px;left:85.2066%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai2-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.3711%;margin-top:-15.5px;left:38.0293%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle15">Saudi</p>
      <p class="g-pstyle15">Arabia</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.7563%;margin-top:-18.7px;left:22.831%;width:171px;"
    >
      <p class="g-pstyle5">Pipelines bypassing</p>
      <p class="g-pstyle5">the Strait of Hormuz</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.4627%;margin-top:-8.6px;left:84.9885%;width:125px;"
    >
      <p class="g-pstyle6">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:17.5195%;margin-top:-8.6px;right:42.5663%;width:78px;"
    >
      <p class="g-pstyle7">Juaymah</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.8973%;margin-top:-8.6px;left:22.831%;width:142px;"
    >
      <p class="g-pstyle8">East-West pipeline</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:21.8733%;margin-top:-8.6px;right:31.4422%;width:64px;"
    >
      <p class="g-pstyle9">Qatar</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.8603%;margin-top:-8.6px;right:76.3925%;width:61px;"
    >
      <p class="g-pstyle7">Yanbu</p>
    </div>
    <div
      id="g-ai2-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.1019%;margin-top:-8.1px;right:25.3797%;width:64px;"
    >
      <p class="g-pstyle14">Muajjiz</p>
    </div>
    <div
      id="g-ai2-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.1019%;margin-top:-8.1px;right:76.6309%;width:64px;"
    >
      <p class="g-pstyle14">Muajjiz</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.106%;margin-top:-8.6px;right:39.5147%;width:92px;"
    >
      <p class="g-pstyle7">Ras Tanura</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.8801%;margin-top:-8.6px;right:69.1724%;width:67px;"
    >
      <p class="g-pstyle7">Muajjiz</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.8746%;margin-top:-8.6px;left:74.0751%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle0">UAE</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:36.5419%;margin-top:-16.6px;left:66.2123%;width:138px;"
    >
      <p class="g-pstyle8">Habshan-Fujairah</p>
      <p class="g-pstyle8">pipeline</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.4612%;margin-top:-16.6px;left:40.3076%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.2168%;margin-top:-8.6px;left:74.4482%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle0">Oman</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-text g-aiAbs"
      style="top:44.3857%;left:2.5674%;width:18.7879%;"
    >
      <p class="g-pstyle10">
        Tanker queue builds at Yanbu as Saudi Arabia reroutes exports from the
        Gulf
      </p>
      <p class="g-pstyle11">(March 17)</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.4255%;margin-top:-8.6px;left:55.327%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle0">Yemen</p>
    </div>
    <div
      id="g-ai2-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.403%;margin-top:-8.1px;right:0.3422%;width:84px;"
    >
      <p class="g-pstyle14">MARCH 15</p>
    </div>
    <div
      id="g-ai2-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.7307%;margin-top:-8.6px;left:90.4044%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle12">500km</p>
    </div>
    <div
      id="g-ai2-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:74.3281%;margin-top:-16.7px;left:0.3973%;width:616px;"
    >
      <p class="g-pstyle13">
        Tanker traffic in Saudi Red Sea ports increased significantly between
        March 2 (<span class="g-cstyle0">97 vessels</span>)
      </p>
      <p class="g-pstyle13">
        and March 15 (<span class="g-cstyle0">134 vessels</span>), suggesting a
        buildup in oil export activity.
      </p>
    </div>
    <div
      id="g-ai2-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.403%;margin-top:-8.1px;right:52.1126%;width:79px;"
    >
      <p class="g-pstyle14">MARCH 2</p>
    </div>
    <div
      id="g-ai2-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.3711%;margin-top:-15.5px;left:89.0156%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle15">Saudi</p>
      <p class="g-pstyle15">Arabia</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.2472%;margin-top:-8.6px;left:41.4876%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:24.6529%;margin-top:-8.6px;left:93.3162%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle4">Gulf of Oman</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:24.1245%;margin-top:-8.6px;left:13.2366%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle4">Red Sea</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:12.896%;margin-top:-8.6px;left:59.0817%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle4">The Gulf</p>
    </div>
    <div
      id="g-ai2-31"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:95.123%;margin-top:-8.1px;left:3.4665%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle16">Red Sea</p>
    </div>
    <div
      id="g-ai2-32"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:95.123%;margin-top:-8.1px;left:54.453%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle16">Red Sea</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:49.2236%;margin-top:-8.6px;left:89.1942%;margin-left:-44.5px;width:89px;"
    >
      <p class="g-pstyle4">Arabia Sea</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post19-vessels-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 1.02990033222591;"
    data-aspect-ratio="1.03"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-post19-vessels-lg-img"
      class="g-post19-vessels-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-vessels-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.6719%;margin-top:-9.2px;left:83.3467%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle1">Iran</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.9903%;margin-top:-9.1px;left:13.959%;width:77px;"
    >
      <p class="g-pstyle2">Jordan</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.1056%;margin-top:-11.2px;left:61.8853%;width:108px;"
    >
      <p class="g-pstyle3">Oil terminals</p>
    </div>
    <div
      id="g-ai3-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.5485%;margin-top:-17.6px;left:35.0486%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:17.2523%;margin-top:-21.8px;left:28.2389%;width:189px;"
    >
      <p class="g-pstyle5">Pipelines bypassing</p>
      <p class="g-pstyle5">the Strait of Hormuz</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:17.4692%;margin-top:-9.7px;left:80.5979%;width:146px;"
    >
      <p class="g-pstyle6">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.7335%;margin-top:-9.2px;right:43.7757%;width:82px;"
    >
      <p class="g-pstyle7">Juaymah</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:22.0604%;margin-top:-7.2px;left:28.2388%;width:158px;"
    >
      <p class="g-pstyle8">East-West pipeline</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.1586%;margin-top:-9.1px;right:33.9564%;width:67px;"
    >
      <p class="g-pstyle9">Qatar</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.2673%;margin-top:-9.2px;right:73.7097%;width:64px;"
    >
      <p class="g-pstyle7">Yanbu</p>
    </div>
    <div
      id="g-ai3-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.0713%;margin-top:-9.2px;right:24.0323%;width:70px;"
    >
      <p class="g-pstyle7">Muajjiz</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.821%;margin-top:-9.2px;right:40.1769%;width:97px;"
    >
      <p class="g-pstyle7">Ras Tanura</p>
    </div>
    <div
      id="g-ai3-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.0713%;margin-top:-9.2px;right:76.3978%;width:70px;"
    >
      <p class="g-pstyle7">Muajjiz</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.0292%;margin-top:-9.2px;right:67.9032%;width:70px;"
    >
      <p class="g-pstyle7">Muajjiz</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.5784%;margin-top:-9.1px;left:70.9386%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle0">UAE</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-text g-aiAbs"
      style="top:30.454%;left:1.5736%;width:13.5484%;"
    >
      <p class="g-pstyle11">
        Tanker queue builds at Yanbu as Saudi Arabia reroutes exports from the
        Gulf
      </p>
      <p class="g-pstyle12">(March 17)</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.2006%;margin-top:-14px;left:63.971%;width:154px;"
    >
      <p class="g-pstyle8">Habshan-Fujairah</p>
      <p class="g-pstyle8">pipeline</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:39.3823%;margin-top:-17.6px;left:41.0701%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai3-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.5318%;margin-top:-9.1px;left:71.2789%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle0">Oman</p>
    </div>
    <div
      id="g-ai3-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.0656%;margin-top:-9.1px;left:54.3253%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle0">Yemen</p>
    </div>
    <div
      id="g-ai3-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.9738%;margin-top:-9.2px;right:4.1526%;width:93px;"
    >
      <p class="g-pstyle7">MARCH 15</p>
    </div>
    <div
      id="g-ai3-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:69.112%;margin-top:-11.1px;left:91.8301%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle13">500km</p>
    </div>
    <div
      id="g-ai3-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.1578%;margin-top:-21.7px;left:1.0346%;width:850px;"
    >
      <p class="g-pstyle14">
        Tanker traffic in Saudi Red Sea ports increased significantly between
        March 2 (<span class="g-cstyle0">97 vessels</span>) and March 15 (<span
          class="g-cstyle0">134 vessels</span
        >),
      </p>
      <p class="g-pstyle14">suggesting a buildup in oil export activity.</p>
    </div>
    <div
      id="g-ai3-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.9738%;margin-top:-9.2px;right:56.9708%;width:87px;"
    >
      <p class="g-pstyle7">MARCH 2</p>
    </div>
    <div
      id="g-ai3-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.5485%;margin-top:-17.6px;left:87.1993%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:2.5606%;margin-top:-9.1px;left:37.5018%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:26.2594%;margin-top:-7.1px;left:87.9773%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle4">Gulf of Oman</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:25.5995%;margin-top:-7.2px;left:17.0369%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle10">Red Sea</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:13.8563%;margin-top:-7.1px;left:57.6388%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle4">The Gulf</p>
    </div>
    <div
      id="g-ai3-31"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:95.1455%;margin-top:-7.2px;left:6.9825%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle10">Red Sea</p>
    </div>
    <div
      id="g-ai3-32"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:95.1455%;margin-top:-7.2px;left:59.1331%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle10">Red Sea</p>
    </div>
    <div
      id="g-ai3-22"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:51.9516%;margin-top:-7.1px;left:84.326%;margin-left:-44.5px;width:89px;"
    >
      <p class="g-pstyle4">Arabia Sea</p>
    </div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post19-vessels-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-post19-vessels-xl-img"
      class="g-post19-vessels-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-vessels-xl.jpg);"
    ></div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.943%;margin-top:-11.2px;left:33.7184%;width:168px;"
    >
      <p class="g-pstyle1">East-West pipeline</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle2">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle3">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-17 18:16 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-17 18:16 -->
<!-- ai file: post19-vessels.ai -->
<style lang="scss">
  #g-post19-vessels-box {
    container-type: inline-size;
    container-name: g-post19-vessels-box;
  }
  #g-post19-vessels-box,
  #g-post19-vessels-box .g-artboard {
    margin: 0 auto;
  }
  #g-post19-vessels-box p {
    margin: 0;
  }
  #g-post19-vessels-box .g-aiAbs {
    position: absolute;
  }
  #g-post19-vessels-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post19-vessels-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post19-vessels-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post19-vessels-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post19-vessels-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post19-vessels-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post19-vessels-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post19-vessels-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post19-vessels-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post19-vessels-xl {
        display: block !important;
      }
    }
  }
  #g-post19-vessels-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-vessels-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-vessels-xs .g-pstyle0 {
    font-weight: 700;
    line-height: 14px;
    height: 14px;
  }
  #g-post19-vessels-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 11px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-xs .g-pstyle2 {
    font-weight: 900;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.27em;
    font-size: 13px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post19-vessels-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 11px;
  }
  #g-post19-vessels-xs .g-pstyle4 {
    font-weight: 500;
    font-style: italic;
    line-height: 14px;
    height: 14px;
    padding-bottom: 4px;
    font-size: 11px;
    color: rgb(123, 123, 123);
  }
  #g-post19-vessels-xs .g-pstyle5 {
    font-weight: 400;
    font-style: italic;
    line-height: 14px;
    height: 14px;
    font-size: 11px;
    text-align: center;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-xs .g-pstyle6 {
    font-weight: 500;
    line-height: 15px;
    height: 15px;
  }
  #g-post19-vessels-xs .g-pstyle7 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 11px;
    text-align: right;
  }
  #g-post19-vessels-xs .g-pstyle8 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 11px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-xs .g-pstyle9 {
    font-weight: 300;
    line-height: 14px;
    height: 14px;
    font-size: 11px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post19-vessels-xs .g-pstyle10 {
    font-weight: 700;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-xs .g-pstyle11 {
    font-weight: 300;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-xs .g-pstyle12 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: right;
  }
  #g-post19-vessels-xs .g-pstyle13 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 13px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-xs .g-pstyle14 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-xs .g-pstyle15 {
    font-weight: 400;
    height: 16px;
  }
  #g-post19-vessels-xs .g-cstyle0 {
    font-weight: 700;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-vessels-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-vessels-sm .g-pstyle0 {
    font-weight: 700;
    line-height: 14px;
    height: 14px;
  }
  #g-post19-vessels-sm .g-pstyle1 {
    font-weight: 900;
    line-height: 16px;
    height: 16px;
    letter-spacing: 0.27em;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post19-vessels-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
  }
  #g-post19-vessels-sm .g-pstyle4 {
    font-weight: 500;
    font-style: italic;
    line-height: 16px;
    height: 16px;
    padding-bottom: 5px;
    color: rgb(123, 123, 123);
  }
  #g-post19-vessels-sm .g-pstyle5 {
    font-weight: 400;
    font-style: italic;
    line-height: 16px;
    height: 16px;
    text-align: center;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-sm .g-pstyle6 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 16px;
  }
  #g-post19-vessels-sm .g-pstyle7 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    text-align: right;
  }
  #g-post19-vessels-sm .g-pstyle8 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-sm .g-pstyle9 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post19-vessels-sm .g-pstyle10 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-sm .g-pstyle11 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-sm .g-pstyle12 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: right;
  }
  #g-post19-vessels-sm .g-pstyle13 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 13px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-sm .g-pstyle14 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-sm .g-pstyle15 {
    font-weight: 400;
    height: 17px;
  }
  #g-post19-vessels-sm .g-cstyle0 {
    font-weight: 700;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-vessels-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-vessels-md .g-pstyle0 {
    font-weight: 400;
    height: 16px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-md .g-pstyle1 {
    font-weight: 400;
    height: 16px;
    font-size: 14px;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-md .g-pstyle2 {
    font-weight: 400;
    height: 16px;
    font-size: 15px;
  }
  #g-post19-vessels-md .g-pstyle3 {
    font-weight: 900;
    height: 16px;
    letter-spacing: 0.27em;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post19-vessels-md .g-pstyle4 {
    font-weight: 400;
    font-style: italic;
    height: 16px;
    font-size: 15px;
    text-align: center;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-md .g-pstyle5 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 17px;
  }
  #g-post19-vessels-md .g-pstyle6 {
    font-weight: 500;
    font-style: italic;
    height: 16px;
    padding-bottom: 7px;
    font-size: 15px;
    color: rgb(123, 123, 123);
  }
  #g-post19-vessels-md .g-pstyle7 {
    font-weight: 400;
    height: 16px;
    font-size: 15px;
    text-align: right;
  }
  #g-post19-vessels-md .g-pstyle8 {
    font-weight: 500;
    height: 16px;
    font-size: 15px;
  }
  #g-post19-vessels-md .g-pstyle9 {
    font-weight: 400;
    height: 16px;
    font-size: 14px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-md .g-pstyle10 {
    font-weight: 700;
    line-height: 18px;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-md .g-pstyle11 {
    font-weight: 300;
    line-height: 18px;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-md .g-pstyle12 {
    font-weight: 400;
    height: 16px;
    font-size: 14px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post19-vessels-md .g-pstyle13 {
    font-weight: 400;
    height: 16px;
  }
  #g-post19-vessels-md .g-pstyle14 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: right;
  }
  #g-post19-vessels-md .g-pstyle15 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 13px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-md .g-pstyle16 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-md .g-cstyle0 {
    font-weight: 700;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-vessels-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 17px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-vessels-lg .g-pstyle0 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-lg .g-pstyle1 {
    font-weight: 900;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.27em;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post19-vessels-lg .g-pstyle2 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-lg .g-pstyle3 {
    font-weight: 400;
    height: 21px;
    font-size: 16px;
  }
  #g-post19-vessels-lg .g-pstyle4 {
    font-weight: 400;
    font-style: italic;
    line-height: 13px;
    height: 13px;
    font-size: 15px;
    text-align: center;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-lg .g-pstyle5 {
    font-weight: 700;
    height: 21px;
    font-size: 19px;
  }
  #g-post19-vessels-lg .g-pstyle6 {
    font-weight: 500;
    font-style: italic;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 18px;
    color: rgb(123, 123, 123);
  }
  #g-post19-vessels-lg .g-pstyle7 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 16px;
    text-align: right;
  }
  #g-post19-vessels-lg .g-pstyle8 {
    font-weight: 500;
    line-height: 13px;
    height: 13px;
  }
  #g-post19-vessels-lg .g-pstyle9 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-lg .g-pstyle10 {
    font-weight: 400;
    font-style: italic;
    line-height: 13px;
    height: 13px;
    font-size: 16px;
    text-align: center;
    color: rgb(151, 151, 151);
  }
  #g-post19-vessels-lg .g-pstyle11 {
    font-weight: 700;
    line-height: 19px;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-lg .g-pstyle12 {
    font-weight: 300;
    line-height: 19px;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-lg .g-pstyle13 {
    font-weight: 400;
    height: 21px;
    font-size: 14px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post19-vessels-lg .g-pstyle14 {
    font-weight: 400;
    height: 21px;
  }
  #g-post19-vessels-lg .g-cstyle0 {
    font-weight: 700;
    color: rgb(176, 42, 41);
  }
  #g-post19-vessels-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-vessels-xl p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-vessels-xl .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-post19-vessels-xl .g-pstyle1 {
    font-weight: 700;
    line-height: 21px;
    height: 21px;
    font-size: 18px;
  }
  #g-post19-vessels-xl .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post19-vessels-xl .g-pstyle3 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
</style>
